import { useContext } from 'react';
import TooltipContext from '../../common/events/context/TooltipContext';
import { MultiSeriesTooltip } from '../../common/tooltip/MultiSeriesTooltip';
import { useLineData } from '../providers/data';
import { jsx as _jsx } from "react/jsx-runtime";
export function LineTooltip() {
  const {
    xAccessor,
    yAccessor,
    colorAccessor,
    colorScale
  } = useLineData();
  const {
    tooltipData,
    tooltipLeft,
    tooltipTop
  } = useContext(TooltipContext);
  return /*#__PURE__*/_jsx(MultiSeriesTooltip, {
    tooltipData: tooltipData,
    tooltipLeft: tooltipLeft,
    tooltipTop: tooltipTop,
    xAccessor: xAccessor,
    yAccessor: yAccessor,
    colorAccessor: colorAccessor,
    colorScale: colorScale
  });
}